import type { Line, Lookups } from "./types";
import { lineTotal } from "./format";

export interface Totals { services: number; insuranceCost: number; subtotal: number; tax: number; total: number }

/**
 * Estimate totals, as the old portal and the printed invoice work them out: lines at
 * quantity × (price − discount), insurance above the free amount at the insurance rate,
 * Wisconsin sales tax when the customer pays tax and the address is in WI.
 */
export function totals(lines: Pick<Line, "quantity" | "price" | "discount">[], insuranceAmount: number, taxed: boolean,
  pricing: Lookups["pricing"]): Totals {
  const services = lines.reduce((s, l) => s + lineTotal(l), 0);
  const insuranceCost = insuranceAmount > pricing.freeInsuranceAmount ? insuranceAmount * pricing.insuranceRate : 0;
  const subtotal = services + insuranceCost;
  const tax = taxed ? Math.round(subtotal * pricing.wisconsinTaxRate * 100) / 100 : 0;
  return { services, insuranceCost, subtotal, tax, total: subtotal + tax };
}
